<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'yourProfile' | translate }}</h1>
      <p class="st-subtitle">{{ 'yourStaffAccountDetails' | translate }}</p>
    </div>
    <button class="st-btn st-btn-secondary" (click)="logout()"><i class="ri-logout-box-line"></i> {{ 'logout' | translate }}</button>
  </div>

  <ng-container *ngIf="loading">
    <div class="st-card sp-profile-head">
      <div class="sp-skeleton sp-skeleton-circle sp-avatar-lg"></div>
      <div style="flex:1;">
        <div class="sp-skeleton sp-skeleton-line" style="width:40%;"></div>
        <div class="sp-skeleton sp-skeleton-line" style="width:25%;"></div>
      </div>
    </div>
    <div class="sp-grid">
      <div class="st-card" *ngFor="let i of [1,2]">
        <div class="sp-skeleton sp-skeleton-line" style="width:50%;"></div>
        <div class="sp-skeleton sp-skeleton-line" style="width:80%;"></div>
        <div class="sp-skeleton sp-skeleton-line" style="width:65%;"></div>
      </div>
    </div>
  </ng-container>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldntLoadProfilePleaseTryAgain' | translate }}
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <div class="st-card sp-profile-head">
      <div class="st-avatar sp-avatar-lg" [class.sd-avatar-photo]="staff.staffImage">
        <img *ngIf="staff.staffImage" [src]="staff.staffImage" alt="{{ staff.name }}" />
        <ng-container *ngIf="!staff.staffImage">{{ staff.initials }}</ng-container>
      </div>
      <div>
        <div class="sp-name">{{ staff.name }}</div>
        <div class="st-subtitle">{{ staff.role }}</div>
        <span class="st-chip st-chip-blue" style="margin-top:6px;">{{ 'employeeId' | translate }}: {{ staff.employeeId }}</span>
      </div>
    </div>

    <div class="sp-grid">
      <div class="st-card">
        <h3 class="st-card-title">{{ 'personalInfo' | translate }}</h3>
        <div class="st-info-grid">
          <div class="st-info-item"><span class="st-info-label">{{ 'dateOfBirth' | translate }}</span><span class="st-info-value">{{ staff.dateOfBirth }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'dateOfJoining' | translate }}</span><span class="st-info-value">{{ staff.dateOfJoining }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'gender' | translate }}</span><span class="st-info-value">{{ staff.gender || ('na' | translate) }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'classTeacherQuestion' | translate }}</span><span class="st-info-value">{{ (staff.isClassTeacher ? 'yes' : 'no') | translate }}</span></div>
          <!-- Own-profile view: contact rows are plain text, not tap-to-call/email. -->
          <div class="st-info-item"><span class="st-info-label">{{ 'phone' | translate }}</span><span class="st-info-value">{{ staff.phone || ('na' | translate) }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'email' | translate }}</span><span class="st-info-value">{{ staff.email || ('na' | translate) }}</span></div>
          <div class="st-info-item st-span-2"><span class="st-info-label">{{ 'school' | translate }}</span><span class="st-info-value">{{ staff.schoolName }}</span></div>
        </div>
      </div>

      <div class="st-card">
        <h3 class="st-card-title">{{ 'address' | translate }}</h3>
        <p class="st-info-value">{{ staff.address || ('notAvailable' | translate) }}</p>

        <h3 class="st-card-title" style="margin-top:18px;">{{ 'classesAndSubjects' | translate }}</h3>
        <div class="sp-tag-list" *ngIf="teachingClasses.length">
          <span class="st-chip st-chip-grey" *ngFor="let c of teachingClasses">{{ classLabel(c) }}</span>
        </div>
        <p class="st-info-value" *ngIf="!teachingClasses.length">{{ 'notAvailable' | translate }}</p>
      </div>
    </div>
  </ng-container>
</div>
